var draft = {
    title: 'SURAT KETERANGAN MEDIS',
    subtitle: 'No. : ......../20',
	arr1: [
		{label:'Nama Pasien',value:''},
		{label:'No. RM',value:''},
		{label:'Umur',value:''},
		{label:'Jenis Kelamin',value:''},
	],
	arr2: [
		{label:'Hari ',value:''},
		{label:'Tanggal',value:''},
		{label:'Dokter Pemeriksa',value:''},
	],
	p1: `Berdasarkan hasil pemeriksaan didapatkan`,
	arr3: [
		{label:'Keluhan Utama',value:''},
		{label:'Pemeriksaan Fisik',value:''},
		{label:'Pemeriksaan Penunjang',value:''},
		{label:'Diagnosa',value:``},
		{label:'Terapi yang diberikan',value:''},
		{label:'Anjuran',value:''},
	],
	p2: 'Demikian keterangan medis ini dibuat untuk digunakan seperlunya.'
};
var sign = `Pekanbaru, <tgl>

Dokter pemeriksa



( <nama_dokter> )`;
import {
    headerImage
} from './headerImage.js';
import { labelValueFormatter } from './helper.js';
let arr1 = labelValueFormatter(draft.arr1,90);
let arr2 = labelValueFormatter(draft.arr2,100);
let arr3 = labelValueFormatter(draft.arr3);
export const docContent = [{
        image: headerImage,
        width: 529
    },
    {
        text: draft.title,
        style: 'title'
	},
	{
        text: '',
        style: 'subtitle'
	},
	{
		columns: [
			[...arr1],[...arr2]
		]
	},
	{
        style: 'paragraph',
        text: draft.p1
	},
	...arr3,
	{
        style: 'paragraph',
        text: draft.p2
	},
	{
        text: '',
        style: 'gap'
	},
	{
		columns: [
			{text:''},
			{
				style: 'sign',
				text: sign
			}
		]
	}
];

////console.log(docContent);